import React from 'react';

/**
 * Simple wrapper component for protected routes
 * 
 * Permission checking and routing is handled once during login in the SignIn component.
 * Admin and super admin users skip permission checks but are still routed to their
 * appropriate dashboards based on their roles and service preferences.
 * 
 * This component now just renders children since:
 * 1. Initial routing decisions are made during login
 * 2. Admin users bypass individual permission checks
 * 3. Regular users have their permissions validated at login
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render
 * @returns {React.ReactNode} - The children components
 */
const DashboardRouter = ({ children }) => {
  // Just render children - routing decision is made during login
  // Admin bypass logic is handled in PermissionGuard components
  return children;
};

export default DashboardRouter; 